import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  structure: {},
  roof: {},
  mAndE: {},
  externals: {},
  sketch: { paths: [] },
  photos: [],
};

export const inspectionSlice = createSlice({
  name: "inspection",
  initialState,
  reducers: {
    addFieldValue: (state, action) => {
      let payload = action.payload;
      let temp = state;
      if (payload.subfield) {
        temp[payload.field][payload.subfield] = payload.value;
        return (state = temp);
      }
      temp[payload.field] = payload.value;
      return (state = temp);
    },

    addInspection: (state, action) => {
      return (state = { ...action.payload });
    },

    resetInspection: (state, action) => {
      return (state = initialState);
    },

    addPhoto: (state, action) => {
      let photos = state.photos || [];
      photos.push(action.payload);
      state.photos = photos;
    },

    removePhoto: (state, action) => {
      let photos = state.photos.filter((photo) => photo !== action.payload);
      state.photos = photos;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  addFieldValue,
  addInspection,
  resetInspection,
  addPhoto,
  removePhoto,
} = inspectionSlice.actions;

export const inspectionSelector = (state) => state.inspection;

export default inspectionSlice.reducer;
